var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"items":_vm.cities,"item-text":"name","loading":_vm.loading,"value":_vm.city,"disabled":!_vm.country_area,"hint":!_vm.country_area
      ? _vm.__('Primeiro escolha um estado', 'address')
      : '',"persistent-hint":"","return-object":""},on:{"change":_vm.handleSelect}},'v-autocomplete',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }